import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './UserActivation.module.css';
import { useRemoteGet } from '@/hooks/useRemoteGet';
import { AccountResourceService } from '@/openapi';
import Label from '@/components/UI/Label';
import { t } from 'i18next';
import Button from '@/components/UI/Button';
import Logo from '@/components/UI/Logo';
import SuccessToast from '@/components/UI/SuccessToast';
import Loader from '@/components/UI/Loader';

const UserActivation = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const key = searchParams.get('key');

	const [message, setMessage] = useState('');
	const hasCalled = useRef(false); // Flag per evitare doppie chiamate
	const [showToast, setShowToast] = useState(false);
	const [toastType, setToastType] = useState<'success' | 'error'>('success');

	const activation = useRemoteGet<void>({
		remoteMethod: async () => {
			if (key) {
				await AccountResourceService.activateAccount({ key });
			}
		},
		lazy: true
	});

	useEffect(() => {
		if (!key) {
			setMessage(t('signup.validateError'));
			setShowToast(true);
			setToastType('error');
			return;
		}

		if (hasCalled.current) return;
		hasCalled.current = true;

		const activate = async () => {
			try {
				await activation.fetch();
				setMessage(t('signup.validateSuccess'));
				setShowToast(true);
				setToastType('success');
				setTimeout(() => navigate('/login'), 10000);
			} catch (error) {
				setMessage(t('signup.validateError'));
				setShowToast(true);
				setToastType('error');
			}
		};

		activate();
	}, [key]);

	return (
		<div className={styles.main_container}>
			<Loader visible={activation.loading} />

			<SuccessToast isVisible={showToast} message={message} onClose={() => setShowToast(false)} type={toastType} />

			<div className={styles.message_container}>
				<div className={styles.message_box}>
					<div className={styles.message_header}>
						<Logo className={styles.logo} onClick={() => {}} />

						<div className={styles.login_title}>
							<Label className={styles.label_title} text={t('signup.registrationSuccess')} />
						</div>
					</div>

					<div className={styles.message_content}>
						<div className={styles.box_btn}>
							<Button
								typeSubmit={'submit'}
								onClick={() => {
									navigate('/login');
								}}
								name={t('login.signIn')}
								color="black"
								background="white"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UserActivation;
